import React, { useState } from "react";
import { Alert } from "reactstrap";
import StepCompleteActionButton from "./StepCompleteActionButton";

import {
    editUser
} from "helpers/fakebackend_helper";

const AreYouUSCitizenStep = ({ step, token, email, onNext }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const updateUser = async (data) => {
        setLoading(true);
        const res = await editUser(token, data);
        setLoading(false);

        if (res.code !== 1) {
            setError(res.message || "Failed");
            return false;
        }
        return true;
    };

    const yesCitizen = async () => {
        const ok = await updateUser({ email, is_us_citizen: 1 });
        if (!ok) return;
        onNext(true); // go to passport_ocr or birth_certificate_ocr step
    };

    const noCitizen = async () => {
        const ok = await updateUser({ email, is_us_citizen: 0 });
        if (!ok) return;
        onNext(false); // go to noncitizen followup step
    };

    return (
        <>
            {error && <Alert color="danger">{error}</Alert>}

            <h1 className="text-dark mb-4 fw-semibold">{step.step_title}</h1>
            <h6 className="text-dark mb-4" style={{ whiteSpace: "pre-line" }}>
                {step.step_description}
            </h6>

            <StepCompleteActionButton label="YES" onClick={yesCitizen} disabled={loading} />
            <div className="mt-3" />
            <StepCompleteActionButton label="NO" onClick={noCitizen} disabled={loading} />
        </>
    );
};

export default AreYouUSCitizenStep;